import React, { useEffect } from 'react';
import { selectScreenshareStreams } from 'features/layout/features/order/orderSlice';
import { gridPanelVoided } from 'features/layout/features/content/contentSlice';
import { useScreenshareGrid } from 'features/screenshare/hooks/useScreenshareGrid';
import ScreenshareGrid from 'features/screenshare/components/ScreenshareGrid';
import { useAppSelector, useAppDispatch } from 'store/hooks';
import { Box } from '@mui/material';
import { SizeWarningPlaceholder } from './SizeWarningPlaceholder';

export const MultiScreenshares = () => {
  const dispatch = useAppDispatch();
  const screenshares = useAppSelector(selectScreenshareStreams);
  const { containerRef, dimensions, size } = useScreenshareGrid(screenshares);

  useEffect(() => {
    if (!screenshares.length) {
      dispatch(gridPanelVoided('screenshare'));
    }
  }, [screenshares.length, dispatch]);

  const showScreens = !size.width || !size.height || (size.width > 500 && size.height > 400);

  return (
    <Box
      ref={containerRef}
      sx={(theme) => ({
        width: '100%',
        height: '100%',
        backgroundColor: theme.room.tileBackground,
        position: 'relative',
        paddingTop: '35px',
      })}
    >
      {showScreens ? (
        <ScreenshareGrid
          screenshares={screenshares}
          cols={dimensions.cols}
          rows={dimensions.rows}
        />
      ) : (
        <SizeWarningPlaceholder />
      )}
    </Box>
  );
};
